import router from '../router'
import { i18n } from './../plugins/i18n.js'

// Adresler build sirasinda VUE_APP_* ortam degiskenlerinden gelir; firma
// listesi build/firmalar.js'te, build ise "yarn build:all" ile aliniyor.
//
// Degisken verilmediginde asagidaki yedek degerler kullanilir, yani "yarn serve"
// ve duz "yarn build" eskisi gibi calisir. Yerelde farkli bir adrese bakmak icin
// auth.js'i DUZENLEMEYIN; kok dizine .env.local acip su satiri koyun:
//     VUE_APP_API_URL=http://localhost:9001/
// (.env.local gitignore'da, yani kimsenin ayarini ezmez.)
const API_URL  = process.env.VUE_APP_API_URL  || 'http://localhost:9001/'
const URL_MAIL = process.env.VUE_APP_URL_MAIL || 'https://nextv3.arkman.com.tr/#/confirm/id?'

//const API_URL='https://nextapi.capavia.com.tr/'; // capavia
//const URL_MAIL='https://nextarkman.capavia.com.tr/#/confirm/id?';// capavia

//const API_URL = 'https://nextapi.burkoncrm.com/'  // burkon arkman canlı
//const URL_MAIL='https://nextarkman.burkoncrm.com/#/confirm/id?';// burkon


//const API_URL = 'https://testapi.arkman.com.tr/' // arkman test v2
//const URL_MAIL='https://testnext.arkman.com.tr/#/confirm/id?';//arkman test v2
//const API_URL='http://192.160.129.94:8090/'; //MORİS LOCAL
//const URL_MAIL='http://192.160.129.94:8091/#/confirm/id?' //MORİS LOCAL
//const URL_MAIL='https://nexarkman.moris.com/#/confirm/id?' // MORİS MAİL 
//const API_URL='https://nextapi.moris.com/' //MORİS API

//const API_URL='http://192.168.1.48:8081/'; // biletiniz
//const URL_MAIL='http://192.168.1.48:8082/#/confirm/id?'; // biletiniz
//const API_URL='http://10.11.92.10:81/'; // HİSARUPD
//const URL_MAIL='http://10.11.92.10:82/#/confirm/id?'; // HİSARUPD
//const API_URL='http://192.168.111.87:8082/' //aviacenter
//const API_URL='http://nextapi.calik.com/' // çalık
//const API_URL='https://nextapi.active.com.tr/' // active
//const URL_MAIL='https://nextarkman.active.com.tr/#/confirm/id?' // aktive
//const API_URL='http://nextapi.serafinatour.com:8080/'
//const API_URL='http://192.168.1.125:8080/' //serafinatour local
//const API_URL='https://nextapi.serafinatour.com/' // serafinatour 
//const API_URL='http://10.128.0.10:8082/' // adors locale
//const API_URL='http://nextapi.adors.com.tr/' //adors
//const API_URL = 'http://10.128.0.10:8080/'  // travelsup
//const API_URL='https://nextapi.4biryana.com/' // biryana
//const API_URL='http://192.168.200.15:8081/' //penisula local menuden iki entegrasyonu aç bilet-alis-entegre faturaentegrasyon
//const API_URL = 'https://nextapi.uygunfly.com.tr/' // uygunfly Yeni TUR
//const API_URL='https://nextapi.easygo.com.tr/' //easygo
//const API_URL='https://nextapi.skyivo.de/' //SKYVİO
//const API_URL='https://f411api.sorgulamax.com.tr/'
//const API_URL = 'http://arkmanapi.cokucuzabilet.com/'//cokucuza bilet
//const API_URL = 'http://84.44.39.36:8080/' //kunet guncel
//const API_URL = 'https://wapi.arkman.com.tr:5353/'
//const API_URL = 'https://flightnextapi-stage.obilet.com:443/' //obilet yeni test
//const API_URL = 'https://flightnextapi.obilet.com:443/' //obilet yeni canlı
//const API_URL = 'https://arkmanapi.etstur.com/' //etsyeni 
//const API_URL = 'http://arkmanapi.marm.com.tr:8080/'//marm 
//const API_URL = 'https://arkmanapi.shallwego.com:443/' // shallwego ACY
//const API_URL = 'https://aapi.oypa.com.tr/' // oyak 
//const API_URL = 'http://172.20.11.53:8090/' //acunmedya
//const API_URL = 'http://f411api.biletbayisi.com.tr:8090/' // limtur 
//const API_URL = 'https://nextapi.flyhisar.com/' // FLYHISAR TR
//const API_URL = 'https://nextapi.flyhisar.de/'  //  // FLYHISAR DE
//const API_URL = 'https://nextapi.metrotravel.com.tr/'  //  // METRO TURIZM
//const API_URL = 'http://nextapi.rotaboo.com/'    // ROTABOO TURIZM
//const API_URL = 'http://localhost:8080/' // KURULUM
//const API_URL = 'http://arkmanapi.otiholding.com/'    // CORAL TURIZM
//const API_URL = 'http://nextapi.gezinomi.com/'    // GEZINOMI TURIZM
//const API_URL = 'http://nextapi.antur.com.tr/'    // ANTUR TURIZM
//const API_URL = 'http://nextapi.sampa.com/'    // sampa TURIZM
//const API_URL = 'https://nextapi.mngtour.com/'    // MNG TURIZM
//const API_URL = 'http://172.20.1.54:8090/'    // PRONTO YENI TURIZM
//const API_URL = 'https://nextapi.easytravel.aero:81/'    // EASY TRAVEL hakvar
//const API_URL = 'http://nextapi.arkas.com/'    // ARKAS
//const API_URL = 'http://nextapi.bekturizm.com/'    // BEK
//const API_URL = 'https://nextapi.msctr.com:443/'  //  // cisalpina 
//const API_URL ='http://10.68.214.137:444/'; // cisalpina test
//const API_URL = 'http://nextapi.polsan.com.tr/'    // POLSAN
//const API_URL = 'http://192.168.0.8:8090/'    // GAZELLA TURIZM
//const API_URL = 'http://10.140.1.10:8060/'    // GAZELLA TURIZM YENI
//const API_URL = 'http://nextapi.visa34.com/'    // HERMES TURIZM
//const API_URL = 'http://nextapi.superpay.tech/'    // SUPERPAY TURIZM
//const API_URL = 'http://nextapi.dorak.com/'    // DORAK TURIZM
//const API_URL = 'http://nextapi.turplus.com.tr:8090/'   // TURPLUS TURIZM
//const API_URL = 'http://172.31.10.178:8070/'   // GAZIGLOBAL TURIZM
//const API_URL = 'https://arkmanapi-tst.yasar.net/' // BIN TUR
//const API_URL = 'https://arkmanapi.enuygun.tech/' // enuygun Yeni TUR
//const API_URL = 'https://arkmanapi.yasar.net/' // BIN TUR LIVE
//const API_URL = 'https://apiarkman-ksa.enuygun.tech/' //enuygun arabistan
//const API_URL = 'http://nextapi.cappadocetour.com/' //cappadoce
//const API_URL = 'https://nextapi.skytur.com/' //sky
//const API_URL = 'https://nextapi.biletsepeti.com/' // biletsepeti Yeni TUR
//const API_URL = 'https://nextapi.ucbilet.com:443/' // geziburda  TUR
//const API_URL = 'http://10.0.0.5:8090/'    // Vizyon TURIZM
//const API_URL = 'http://192.168.1.105:8093/'   // RITMIX -profit TURIZM
//const API_URL = 'https://nextapi.freebirdtravel.com:443/'  //freebirdtravel 
//const API_URL = 'https://nextapi.akyakatur.com.tr/'  //akyakatur
//const API_URL = 'http://nextapi.dessin.net/'  //dessin
//const API_URL = 'http://192.168.1.253:8080/'    // Kontour TURIZM
//const API_URL = 'https://nextapi-stage.biletsepeti.com/' // biletsepeti STAGE TUR
//const API_URL = 'https://nextapi.entas.com.tr/' // ENTAS  TUR CANLI
//const API_URL = 'http://testapi.entas.com.tr/' // ENTAS TUR MUHASEBE TEST
//const API_URL=  'https://nextapi.vanessatur.com.tr/' //VANESSA TUR
//const API_URL = 'http://10.99.0.9/'// ege icracatçılar billiği
//const API_URL='http://nextapiv2.arkman.com.tr/' // YENİ SERVER TEST

//const API_URL='https://nextapi.serafinatour.com.tr/' // SERAFİNA
//const API_URL='http://192.168.1.125:8080/' // serefina local 
//const API_URL='http://192.168.70.5:81/' // express turizm
//const API_URL='http://192.168.2.28:8080/' // SERAFİNA İP
//const API_URL='https://nextapi.lidyateknoloji.com/' // eski ykm tur - lidaya teknoloji 
//const API_URL='http://192.168.109.10:8081/' // tatilsa
//const API_URL='https://nextapi.ucuzyolu.com/' // ucuzyolu.com
//const API_URL='https://nextapi.ikglb.com/' // ikglb
//const API_URL='http://10.128.0.10:8080/' // wtatil
//const API_URL='http://185.255.175.4:8080/' //wtatil yeni
//const API_URL='http://4.245.184.101:8080/' // WTATİL en son

//const API_URL='http://192.168.1.142:8082/' //İKGLOBL YENİ
//const API_URL = 'https://arkmanapi.otiholding.com/'  //OTİHOLDİNG
//const API_URL = 'https://nextapi.pttanadolum.com.tr/'  //PTTANADOLUM
//const API_URL='http://nextapi.dianatravel.com.tr/' // dllfy
//const API_URL='http://10.0.0.10:81/' // sesjoy LOCAL
//const API_URL='http://nextapi.sesjoytour.com:81/' // SESJOY WEB
//const API_URL='http://142.132.146.98:444/' // UCUZYOL TEST
//const API_URL='http://testapi.dianatravel.com.tr/' // dfly_test
//const API_URL='http://213.239.205.170:81/' //ucbilet test
//const API_URL='http://nextapi.ucbilet.com/' // ucbilet canli
//const API_URL='https://next.satgurutravel.com/api/' // SATGURU WEB 
//const API_URL='http://192.168.6.251:81/' // SATGURU LOCAL
//const API_URL='http://10.0.0.110:81/' // ZESA LOCAL
//const API_URL='http://nextapi.zesatravel.com/' // ZESA web
//const API_URL ='http://10.1.1.39:81/' // hitit apptravel local
//const API_URL ='http://192.168.12.14:81/' //honest travel local
//const API_URL='http://nextapi.honesttravelgroup.com:8090/' //honest travel web
//const API_URL='http://10.14.2.53:8081/' //bay travel b2b tobe turizm
//const API_URL='http://192.168.1.254:81/' //namila local
//const API_URL='http://194.31.59.148:81/' //Vizyon tur local
//const API_URL='http://nextapi.vizyontur.com.tr/' //Vizyon tur web
//const API_URL='https://nextapi.thenoortravel.com/' // thenoo travel sinpaş
//const API_URL='https://nextapi.atgturkey.tr/' //ATG TURKEY


//const URL_MAIL='http://4.245.184.101:8081/' // WTATİL en son
//const URL_MAIL='http://192.168.111.87:8081/#/confirm/id?' // aviacenter
//const URL_MAIL='http://nextarkman.calik.com/' //çalık
//const URL_MAIL='http://192.168.1.125:8082/' // serafinatour local
//const URL_MAIL='https://nextarkman.serafinatour.com/' //serafinatour
//const URL_MAIL='https://nextarkman.atgturkey.tr/' //ATG TURKEY
//const URL_MAIL='https://nextarkman.thenoortravel.com/#/confirm/id?' // thenootravel sinpaş
//const URL_MAIL ='https://arkman-ksa.enuygun.tech/#/confirm/id?' // enuygun arabistan 
//const URL_MAIL='http://192.168.1.254:82/#/confirm/id?' // namila locale
//const URL_MAIL='http://10.128.0.10:8080/#/confirm/id?' // adors locale
//const URL_MAIL='http://nextarkman.adors.com.tr/#/confirm/id?' // adors
//const URL_MAIL='http://10.128.0.10:8089/#/confirm/id?';//travelsup
//const URL_MAIL='https://nextarkman.4biryana.com/#/confirm/id?' // biryana
//const URL_MAIL='http://10.14.2.53/#/confirm/id?' //b2b
//const URL_MAIL='http://nextarkman.wtatil.com/#/confirm/id?'  //wtatil
//const URL_MAIL='http://192.168.200.15:8080/#/confirm/id?' // penisula local
//const URL_MAIL = 'https://nextarkman.uygunfly.com.tr/#/confirm/id?' // uygunfly Yeni TUR
//const URL_MAIL='https://nextarkman.easygo.com.tr/#/confirm/id?' //easygo
//const URL_MAIL='https://nextarkman.skyivo.de/#/confirm/id?' //SKYVİO
//const URL_MAIL = 'https://portal.entas.com.tr/#/confirm/id?' // ENTAS
//const URL_MAIL = 'http://nextarkman-stage.biletsepeti.com/#/confirm/id?' //biletsepeti
//const URL_MAIL = 'http://192.168.1.253:8081/#/confirm/id?'    // Kontour TURIZM
//const URL_MAIL = 'http://nextarkman.dessin.net/#/confirm/id?' // dessin
//const URL_MAIL = 'https://nextarkman.akyakatur.com.tr/#/confirm/id?' // akyakatur 
//const URL_MAIL = 'https://nextarkman.freebirdtravel.com/#/confirm/id?' // freebirdtravel TURIZM
//const URL_MAIL = 'http://192.168.1.105:8080/#/confirm/id?' // RITMIX -profit TURIZM
//const URL_MAIL = 'http://10.0.0.5:8070/#/confirm/id?'    // Vizyon TURIZM local
//const URL_MAIL = 'http://next.vizyontur.com.tr/#/confirm/id?'    // Vizyon TURIZM web
//const URL_MAIL = 'https://nextarkman.ucbilet.com/#/confirm/id?' //geziburda
//const URL_MAIL = 'https://nextarkman.biletsepeti.com/#/confirm/id?' //biletsepeti admin@biletsepeti.com
//const URL_MAIL = 'https://nextarkman.skytur.com/#/confirm/id?' //sky
//const URL_MAIL = 'http://nextarkman.cappadocetour.com/#/confirm/id?' //cappadoce
//const URL_MAIL = 'https://arkmannext.yasar.net/#/confirm/id?'  // BIN TUR LIVE
//const URL_MAIL = 'https://arkman.enuygun.tech/#/confirm/id?'  // enuygun Yeni TUR
//const URL_MAIL = 'https://arkmannext-tst.yasar.net/#/confirm/id?'  // BIN TUR
//const URL_MAIL = 'http://172.31.10.178:8080/#/confirm/id?'  // GAZIGLOBAL TURIZM
//const URL_MAIL = 'http://next.turplus.com.tr:8080/#/confirm/id?'  // TURPLUS TURIZM
//const URL_MAIL = 'http://nextarkman.dorak.com/#/confirm/id?' // Dorak TURIZM
//const URL_MAIL = 'http://nextarkman.superpay.tech/#/confirm/id?'    // SUPERPAY TURIZM
//const URL_MAIL = 'http://nextarkman.visa34.com/#/confirm/id?' // HERMES TURIZM
//const URL_MAIL = 'http://10.140.1.10:8060/#/confirm/id?'  //  // GAZELLA TURIZM
//const URL_MAIL = 'http://nextarkman.polsan.com.tr/#/confirm/id?' // POLSAN
//const URL_MAIL = 'https://nextarkman.msctr.com:443/#/confirm/id?' //  cisalpina
//const URL_MAIL = 'http://nextarkman.bekturizm.com/#/confirm/id?' // BEK
//const URL_MAIL = 'http://nextarkman.arkas.com/#/confirm/id?' // ARKAS
//const URL_MAIL = 'https://next.easytravel.aero:80/#/confirm/id?' // EASY TRAVEL hakvar
//const URL_MAIL = 'http://172.20.1.54:8080/#/confirm/id?'  //  // PRONTO YENI TURIZM
//const URL_MAIL = 'https://nextarkman.mngtour.com/#/confirm/id?'  //  // MNG TURIZM
//const URL_MAIL = 'http://nextarkman.sampa.com.tr/#/confirm/id?'  //  // sampa TURIZM
//const URL_MAIL = 'http://nextarkman.antur.com.tr/#/confirm/id?'  //  // ANTUR TURIZM
//const URL_MAIL = 'http://nextarkman.gezinomi.com/#/confirm/id?'  //  // GEZINOMI TURIZM
//const URL_MAIL = 'http://nextarkman.otiholding.com/#/confirm/id?'  //  // CORAL TURIZM
//const URL_MAIL = 'http://localhost:8081/#/confirm/id?' // KURULUM
//const URL_MAIL = 'http://nextarkman.rotaboo.com/#/confirm/id?'  //  // ROTABOO TURIZM
//const URL_MAIL = 'http://nextarkman.metrotravel.com.tr/#/confirm/id?'  //  // METRO TURIZM
//const URL_MAIL = 'https://nextarkman.flyhisar.de/#/confirm/id?' //  FLYHISAR DE
//const URL_MAIL = 'https://nextarkman.flyhisar.com/#/confirm/id?' //  FLYHISAR TR
//const URL_MAIL = 'http://f411next.biletbayisi.com.tr:8091/#/confirm/id?' //limtur
//const URL_MAIL = 'http://172.20.11.53:8091/#/confirm/id?' //acunmedya
//const URL_MAIL = 'https://anext.oypa.com.tr/#/confirm/id?' //oyak  https://anext.oypa.com.tr/#/login
//const URL_MAIL = 'https://arkmannext.shallwego.com/#/confirm/id?' // shallwego ACY
//const URL_MAIL = 'https://arkman.etstur.com/#/confirm/id?' // etsyeni  
//const URL_MAIL = 'http://arkman.marm.com.tr/#/confirm/id?' // marm
//const URL_MAIL = 'http://localhost:1001/#/confirm/id?'
//const URL_MAIL = 'https://nextv2.arkman.com.tr/#/confirm/id?' //arkman
//const URL_MAIL = 'https://testnext.arkman.com.tr/#/confirm/id?' //arkman test
//const URL_MAIL = 'http://arkman.cokucuzabilet.com/#/confirm/id?'
//const URL_MAIL = 'http://muhasebe.kunet.com.tr/#/confirm/id?' //kunet
//const URL_MAIL = 'https://flightnext-stage.obilet.com:443/#/confirm/id?' //obilet yeni test
//const URL_MAIL = 'https://flightnext.obilet.com:443/#/confirm/id?' //obilet yeni canlı
//const URL_MAIL='https://nextapi.vanessatur.com.tr/#/confirm/id?' // VANESSA TUR
//const URL_MAIL = 'http://10.99.0.9/#/confirm/id?' // ege icracatçılar billiği
//const URL_MAIL='http://nextapiv2.arkman.com.tr/#/confirm/id?' // yeni server test
//const URL_MAIL='http://192.168.70.5:81/#/confirm/id?' // express turizm
//const URL_MAIL='http://next.serafina.com.tr/#/confirm/id?' // serafina
//const URL_MAIL='http://192.168.1.125:8082/#/confirm/id?' //serefina local
//const URL_MAIL='https://nextarkman.serafinatour.com/#/confirm/id?' // serefina web 
//const URL_MAIL='http://192.168.2.28:8080/#/confirm/id?' // serafina ip
//const URL_MAIL='https://nextapi.lidyateknoloji.com/#confirm/id?' // eski yekmtur - lidya teknoloji 
//const URL_MAIL='http://192.168.109.10:8080/#confirm/id?' // tatilsa
//const URL_MAIL='https://nextarkman.ucuzyolu.com/#/confirm/id?' // ucuzyol
//const URL_MAIL='https://nextapi.ikglb.com/#/confirm/id?' // ikglb
//const URL_MAIL='https://nextapitest.msctr.com/#/confirm/id?';//cisalpina
//const URL_MAIL='http://testnext.arkman.com.tr/#/confirm/id?'; // ARKMAN TEST v2
//const URL_MAIL='http://192.168.1.142:8082/#/confirm/id?' // ikglbl
//const URL_MAIL = 'https://arkman.otiholding.com/#/confirm/id?'  //OTİHOLDİNG
//const URL_MAIL = 'http://arkman.pttanadolum.com.tr/#/confirm/id?'  //PTT ANADOLUM
//const URL_MAIL ='http://next.dianatravel.com.tr/#/confirm/id?' // dlfly
//const URL_MAIL ='http://10.0.0.10/#/confirm/id?' // sesjoy local
//const URL_MAIL='http://next.sesjoytour.com:85/#/confirm/id?' // SESJOY WEB 
//const URL_MAIL ='http://142.132.146.98:445/#/confirm/id?'
//const URL_MAIL ='http://nextarkman.ucbilet.com/#/confirm/id?' // ucman canli
//const URL_MAIL ='https://next.satgurutravel.com/#/confirm/id?' // SATGURU
//const URL_MAIL='http://10.1.1.39/#/confirm/id?' // hitit apptravel local
//const URL_MAIL ='http://next.zesatravel.com/#/confirm/id?' // zesa web
//const URL_MAIL='http://192.168.12.14:81/#/confirm/id?' //honest travel local                     
//const URL_MAIL='https://f411next.sorgulamax.com.tr/#/confirm/id?'


const MIDDLEWARE_URL = 'https://middleware.arkman.com.tr/'


const REPORTBRO_URL = 'http://reportbro.arkman.com.tr'
//const REPORTBRO_URL = 'http://wapi.arkman.com.tr:8801'

const CLINISTA_API_URL = 'https://services.arkman.com.tr/Clinista/'
//const CLINISTA_API_URL = 'https://localhost:44308/'

const HOTELRUNNER_API_URL = 'https://services.arkman.com.tr/runner/'
//const HOTELRUNNER_API_URL = 'https://localhost:7114/'

const PAXDRIVE_API_URL = 'https://services.arkman.com.tr/PaxDrive/'
//const PAXDRIVE_API_URL = 'http://localhost:54637/'


const TOKEN_URL = API_URL + 'token'

var HOTELRUNNERUSERNAME = 'ArkmanRunner'
var HOTELRUNNERUSERPASS = '13579ArkRun2468'

const PAXIMUM_API_URL = 'https://service.paximum.com/v2/'

//var BOOKING_API_URL = 'https://api.sembilet.com/'
// var BOOKING_API_URL = 'https://bookingapi.arkman.com.tr/'
var BOOKING_API_URL= 'https://nexttextbookingapi.arkman.com.tr/'



// const OCTET_API_PARTNER_CODE = 'ARKMANBILGISAYAR' //test
// const OCTET_API_SECRET_KEY = 'ARK17MARK89HSADT5' //test
// const API_KULLANICI_ADI = '' //test
// const OCTET_API_URL = 'https://uat.octet.com.tr/api/http_api.aspx' //test

//  const OCTET_API_PARTNER_CODE = 'ARKMANBILGISAYAR' //eski canlı
//   const OCTET_API_SECRET_KEY = 'ARK73GDVC54JFSLLH' //eski canlı
//  const API_KULLANICI_ADI = 'arkmanapi' //eski canlı
//  const OCTET_API_URL = 'https://secure.octet.com.tr/api/http_api.aspx ' // eski canlı

const OCTET_API_PARTNER_CODE = 'ARKMANBILGISAYAR' //canlı
  const OCTET_API_SECRET_KEY = 'ARK73GDVC54JFSLLH' //canlı 
 const API_KULLANICI_ADI = 'arkmanapi' //canlı
 const OCTET_API_URL = 'https://bridgeapi.octet.com.tr/functions' // canli

const OCTET_API_PARTNER_CODE_TEST = 'ARKMANBILGISAYARTEST' //TEST
const OCTET_API_SECRET_KEY_TEST = 'ARK73GDVC54JFSLLH' //TEST
const API_KULLANICI_ADI_TEST = 'arkmanapi' //TEST
 const OCTET_API_URL_TEST= 'https://qaportalbridgeapi.octet.com.tr/functions' // TEST
export default {
  user: {
    authenticated: false,
    email: ''
  },
  API_URL: API_URL,

  HOTELRUNNER_API_URL: HOTELRUNNER_API_URL,
  URL_MAIL: URL_MAIL,
  REPORTBRO_URL: REPORTBRO_URL,
  HOTELRUNNERUSERNAME: HOTELRUNNERUSERNAME,
  HOTELRUNNERUSERPASS: HOTELRUNNERUSERPASS,
  PAXDRIVE_API_URL: PAXDRIVE_API_URL,
  CLINISTA_API_URL: CLINISTA_API_URL,
  OCTET_API_PARTNER_CODE: OCTET_API_PARTNER_CODE,
  OCTET_API_SECRET_KEY: OCTET_API_SECRET_KEY,
  API_KULLANICI_ADI: API_KULLANICI_ADI,
  OCTET_API_URL: OCTET_API_URL,
  PAXIMUM_API_URL:PAXIMUM_API_URL,
  BOOKING_API_URL:BOOKING_API_URL,
  MIDDLEWARE_URL:MIDDLEWARE_URL,

loginnextv2(a,b){

window.location.href = 'https://nextv3.arkman.com.tr/#/login?user=' + a + '&p=' + b;
return;
},


  login(context, creds, redirect) {

    

    context.$http.post(TOKEN_URL, creds).then((response) => {
      this.user.authenticated = true
      this.user.email = creds.Email
      window.localStorage.setItem('response', JSON.stringify(response.body))
      window.localStorage.setItem('token', response.body.Token.token);
        router.push({
          path: 'anasirket'
        })
        context.bekle = false;
        window.location.reload(true);
   



      if (redirect) {
        context.e1 = 2
        context.errorAlert = false

        var sirketler = []

        Object.keys(response.body.MusteriDbler).forEach(key => {
          var sirket = {
            text: response.body.MusteriDbler[key].Ad,
            id: response.body.MusteriDbler[key].MusteriKod
          }
          sirketler.push(sirket)
        });

        context.AnaSirketler = sirketler;
        context.AnaSirket = sirketler[0];


      } else {
        context.e1 = 2
        context.errorAlert = false

        var sirketlers = []

        Object.keys(response.body.MusteriDbler).forEach(key => {

          var sirket = {
            text: response.body.MusteriDbler[key].Ad,
            id: response.body.MusteriDbler[key].MusteriKod
          }
          sirketlers.push(sirket)
        });
        context.AnaSirketler = sirketlers;
        context.AnaSirket = sirketlers[0];


      }

    }, (response) => {
      if (response.status === 0) {
        context.errorMsg = 'Service Unavailable'
        context.errorAlert = true
        context.bekle = false;
      } else {
       
        context.errorMsg =  i18n.tc('Failed-to-log-in-Please-check-your-information.')
        context.errorAlert = true
        context.bekle = false;
      }
    })
  },
  logingiris2(context, creds, redirect) {
    
    context.$http.post(TOKEN_URL, creds).then((response) => {


      this.user.authenticated = true
      this.user.email = creds.Email
      window.localStorage.removeItem('response')
      window.localStorage.setItem('response', JSON.stringify(response.body))
      var responseJSON = JSON.parse(window.localStorage.getItem('response'));
      window.localStorage.setItem('token', responseJSON.Token.token); // 
     
      router.push({
        path: '/'
      })

    }, (response) => {
      if (response.status === 0) {
        context.text1 = 'Service Unavailable'
        context.snackbar = true
      } else {
        context.text1 =  i18n.tc('Failed-to-log-in-Please-check-your-information.')
        context.snackbar = true
      }
    })
  },
 async logingiris(context, creds, redirect) {
  
  try {
    const response = await context.$http.post(TOKEN_URL, creds)

    this.user.authenticated = true
    this.user.email = creds.Email

    const responseBody = response.body
    window.localStorage.setItem('response', JSON.stringify(responseBody))
    window.localStorage.setItem('token', responseBody.Token.token)

    return true // başarılı dönüş
  } catch (error) {
    if (error.status === 0) {
      context.text1 = 'Service Unavailable'
    } else {
      context.text1 = i18n.tc('Failed-to-log-in-Please-check-your-information.')
    }
    context.snackbar = true
    throw error
  }
},
  logingiris_yeni(context, creds) {
    
    context.$http.post(TOKEN_URL, creds).then((response) => {


      this.user.authenticated = true
      this.user.email = creds.Email
      window.localStorage.removeItem('response')
      window.localStorage.setItem('response', JSON.stringify(response.body))
      var responseJSON = JSON.parse(window.localStorage.getItem('response'));
      window.localStorage.setItem('token', responseJSON.Token.token); //
     
      router.push({
        path: '/'
      })

    }, (response) => {
      if (response.status === 0) {
        context.text1 = 'Service Unavailable'
        context.snackbar = true
      } else {
        context.text1 =  i18n.tc('Failed-to-log-in-Please-check-your-information.')
        context.snackbar = true
      }
    })
  },
  logout() {
    window.localStorage.removeItem('token')
    window.localStorage.removeItem('cretials')
    window.localStorage.removeItem('hrrezervasyon')
    window.localStorage.removeItem('response')
    window.localStorage.removeItem('WebUserManageLoad')
    window.localStorage.removeItem('container')
    window.localStorage.removeItem('bookingParams')
    window.localStorage.removeItem('allocateParams')
    window.localStorage.removeItem('transferBookingParams')
    window.localStorage.removeItem('nextMuhasebe')
    window.localStorage.removeItem('sovos')
    
    var m1=window.localStorage.getItem("AktifUyelikPaketID");
    var m2=window.localStorage.getItem("po");
    var m3=window.localStorage.getItem("UlkeID");
    var m4=window.localStorage.getItem("gender");
    var m5=window.localStorage.getItem("active");
     //var m6=window.localStroge.getItem("transferBookingParams");
    //var m7=window.localStroge.getItem("uyelikBitisi");
    // var m8=window.localStroge.getItem("shopCartID");
    // var m9=window.localStroge.getItem("allocateParams");
    // if (m9!=null)
    // {
    //   window.localStorage.removeItem('allocateParams');
    // }
    // if (m8!=null)
    // {
    //   window.localStorage.removeItem('shopCartID');
    // }
    // if (m7!=null)
    // {
    //   window.localStorage.removeItem('uyelikBitisi');
    // }
    // if (m6!=null)
    // {
    //   window.localStorage.removeItem('transferBookingParams');
    // }
    if (m1!=null)
    {
      window.localStorage.removeItem('AktifUyelikPaketID');
    }
    if (m2!=null)
    {
        window.localStorage.removeItem('po');
    }
    if (m3!=null)
    {
       window.localStorage.removeItem('UlkeID');
    }
    if (m4!=null)
    {
       window.localStorage.removeItem('gender');
    }
    if (m5!=null)
    {
         window.localStorage.removeItem('active');
    }
   
    
   
    this.user.authenticated = false
    this.user.name = ''
    router.push({
      path: '/login'
    })

  },
  
  checkAuth() {
    var jwt = window.localStorage.getItem('token')
    var email = window.localStorage.getItem('email')
    if (jwt) {
      this.user.authenticated = true
      this.user.name = email
      return true
    } else {
      this.user.authenticated = false
      this.user.name = ''
      return false
    }
  },
  getAuthHeader() {
    return window.localStorage.getItem('token')
  },
  getAuthCompaniesInfo(){
    let credentials = JSON.parse(window.localStorage.getItem('credentials'));
    return {
      'Authorization': 'Bearer ' + window.localStorage.getItem('token'),
      'CariSirketNo': credentials.SirketKodu.toString(),
      'CoperSirketNo': credentials.CoperSirketNo.toString(),
      'MuhasebeSirketNo': credentials.MuhasebeSirketNo.toString(),
    }
  },
}